import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取阿里云userId
 * @return {*}
 */
export function getAliyunUserId() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Resource/Auth/GetAliyunUserId`,
    method: 'get'
  })
}

/**
 * 获取视频上传token
 * @param {{title:string, fileName:string}} data
 */
export function getUploadVideoToken(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Resource/Auth/GetUploadVideoToken`,
    method: 'post',
    data
  })
    .then(({ result, detail }) => (result.code === 0 ? detail : null))
    .catch(() => null)
}

/**
 * 刷新视频上传token
 * @param {string} videoId
 */
export function refreshUploadVideo(videoId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Resource/Auth/RefreshUploadVideo`,
    method: 'post',
    data: {
      videoId
    }
  })
    .then(({ result, detail }) => (result.code === 0 ? detail : null))
    .catch(() => null)
}

/**
 * 视频上传成功通知
 * @param {Object} data
 */
export function upsertResource(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Resource/Auth/OnUploaded`,
    method: 'post',
    data
  })
}

/**
 * 获取资源详情
 * @return {*}
 */
export function getResourceDetail(id) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Resource/Auth/GetResourceDetail`,
    method: 'post',
    data: {
      id
    }
  })
    .then(({ result, detail }) => (result.code === 0 ? detail : null))
    .catch(() => null)
}

/**
 * 获取资源详情,根据videoId
 * @return {*}
 */
export function getPlayInfo(videoId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Resource/Api/GetPlayInfo?videoId=${videoId}`,
    method: 'get'
  })
    .then(({ result, detail }) => (result.code === 0 ? detail : null))
    .catch(() => null)
}
